import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useOidc } from '@nohara-dxdev/react-oidc';

import { paths } from '@/config/paths';

const HomePage = () => {
  const navigate = useNavigate();
  const { isAuthenticated, isLoading } = useOidc();

  useEffect(() => {
    if (isLoading) {
      // Still loading, wait
      return;
    }

    if (isAuthenticated) {
      // User is authenticated, redirect to plans
      navigate(paths.plans.path, { replace: true });
    } else {
      // User is not authenticated, redirect to login
      navigate(paths.auth.login.path, { replace: true });
    }
  }, [navigate, isAuthenticated, isLoading]);

  // Return null since we're redirecting immediately
  return null;
};

export default HomePage;
